import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'hooks';
import { PATHS } from 'routes/routePaths';
import LoadingScreen from 'components/feedback/LoadingScreen';

/**
 * Gate for authenticated areas. Renders nested routes only when a user
 * session exists. While auth state is resolving we show a loading screen
 * to avoid a flash of the login page on refresh.
 *
 * Usage (in router config):
 *   <Route element={<ProtectedRoute />}>
 *     <Route path="/student" element={<StudentDashboard />} />
 *   </Route>
 */
export default function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingScreen />;

  if (!user) {
    // Preserve where the user was headed so we can return them post-login.
    return <Navigate to={PATHS.LOGIN} replace state={{ from: location }} />;
  }

  return <Outlet />;
}
